import * as React from 'react';
import IOktaMfaModel from './Model';
import Expandable from 'apmui/components/Expandable';
import ProgressAnimation from 'apmui/components/ProgressAnimation';

interface ISharedSecretProps {
    okta: IOktaMfaModel;
    showSecret: boolean;
}

/*
 * This component is used to display QR code and shared secret(optional).
 * It will be used for OTP as well as PUSH enrollment.
 */
class SharedSecret extends React.Component<ISharedSecretProps> {
    render() {
        const { strings, state } = this.props.okta.oktaMfa;
        if (!state.hasEnrollInfo) {
            return <ProgressAnimation />;
        }
        let image;
        if (state.isPush) {
            image = <img src={state.pushEnrollInfo.qrcode} alt="QR code" />;
        } else {
            image = <img src={state.enrollInfo.qrcode} alt="QR code" />;
        }
        return (
            <div>
                {image}
                {this.props.showSecret && (
                    <div className="apmui-page-okta-mfa-expandable">
                        <Expandable caption={strings.moreOptionsToEnroll} captionClassName="apmui-link">
                            <div>
                                <p>{strings.oktaVerifyTotpSetup}</p>
                                <h3>{state.enrollInfo.secret}</h3>
                            </div>
                        </Expandable>
                    </div>
                )}
            </div>
        );
    }
}

export default SharedSecret;
